// src/utils/geoUtils.js

/**
 * 射線法 (Ray Casting Algorithm)
 * 判斷一個座標點 (point) 是否在多邊形 (polygon) 內
 * @param {Array} point [lat, lng]
 * @param {Array} polygon [[lat, lng], [lat, lng], ...]
 * @returns {boolean}
 */
export const isPointInPolygon = (point, polygon) => {
  const [lat, lng] = point;
  let inside = false;
  
  if (!polygon || polygon.length === 0) return false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    
    const intersect = ((yi > lng) !== (yj > lng)) &&
      (lat < (xj - xi) * (lng - yi) / (yj - yi) + xi);
      
    if (intersect) inside = !inside;
  }
  return inside;
};